import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import '../../../cssFiles/productPages.scss';
import Footer from '../../layouts/footer';
import Headers from '../../layouts/header';
import { StatisticCard } from '@ant-design/pro-components';
import 'antd/dist/reset.css';
import Celebration from '../../layouts/celebration';
// import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper/modules";
import { useRef } from 'react';
import { FaAngleRight, FaAngleLeft} from "react-icons/fa";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import ProductCards from '../productComparison/productCards';
import { leadServiceHelper } from '../../../services/leadServices';

const features = [
  {
    icon: '/images/premium/flexible.png',
    title: 'Momentum Strategy',
    desc: 'Stocks with technical momentum due to news and events related to the company & industry.'
  },
  {
    icon: '/images/premium/performance_gaurantee_orange.png',
    title: 'Service Guarantee',
    desc: 'Service will be active until 20 research calls are delivered. No annual or quarterly charges!'
  },
  {
    icon: '/images/premium/no-profits-sharing.png',
    title: 'Free Portfolio Review',
    desc: 'Get one time guidance on your current portfolio.'
  },
  {
    icon: '/images/premium/no-lock-in-period.png',
    title: 'Risk Management',
    desc: 'Stocks with moderate downside risk. Strict stop loss and target to further minimize risk.'
  },
  {
    icon: '/images/premium/zero_brokerage03012019.png',
    title: '360o Research Report',
    desc: '1 pager analysis of technical momentum due to news & events for the stock & industry.'
  },
  {
    icon: '/images/premium/risk_orange4.png',
    title: 'Research Desk Access',
    desc: 'Get additional insights on research reports & weekly portfolio update from the research desk.'
  },
];

const plans = [
  {
    title: 'p360° Premium',
    popular: true,
    returns: '25% returns objective* over ~12 months',
    brokerage: ' ',
    price: '₹20000 + GST',
    timeLimit: 'Service active until returns delivered',
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Balanced Strategy',
    guarantee: 'Service Guarantee',
    research: 'Research Desk Access',
    mainPage:  '/products/premium' 
  },
  // {
  //   title: 'p360° Momentum',
  //   returns: '5-10% returns objective* over 2-6 Weeks',
  //   price: '₹20000 + GST',
  //   timeLimit: 'No Time Limit',
  //   stocks: '20 Stocks',
  //   button: 'Learn More',
  //   strategy: 'Momentum Strategy',
  //   guarantee: 'No Service Guarantee',
  //   research: '360° Research Note (1 Page)',
  //   mainPage:  '/products/momentum' 

  // },
  {
    title: 'p360° Mid Term',
    returns: '20-25% returns objective* over 6-9 months',
    price: '₹15000 + GST',
    timeLimit: 'Service active until 10 stocks delivered',
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Growth Strategy',
    guarantee: 'No Service Guarantee',
    research: '360° Research Reports (4 Pages)',
    mainPage:  '/products/midterm' 
  },
  {
    title: 'p360° Long Term',
    returns: 'More than 50% returns objective* over 1-2 years!',
    price: '₹15000 + GST',
    timeLimit: 'Service active until 5 stocks delivered',
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Growth+Value Strategy',
    guarantee: 'No Service Guarantee',
    research: '360° Research Reports (8 Pages)',
    mainPage:  '/products/longterm'  
  },
  {
    title: 'p360° Multibagger',
    popular: false,
    returns: 'More than 100% returns objective* over 2-3 years',
    price: '₹25000 + GST',
    timeLimit: 'Service active until 5 stocks delivered',
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Balanced Strategy',
    guarantee: 'Service Guarantee',
    research: 'Research Desk Access',
    mainPage:  '/products/multibagger' 
  },
];

const researchCalls = [
  {
    name: 'SAMMAAN CAP',
    entry: '₹ 123',
    entryDate:'04 Jun 2025',
    exitDate:'12 Jun 2025',
    exit: '₹ 130',
    returns: '5.7%',
    trend: 	5.7
  },
  {
    name: 'Shakti Pump Ltd',
    entry: '₹ 847',
    entryDate:'20 May 2025',
    exitDate:'10 Jun 2025',
    exit: '₹ 977',
    returns: '15.3%',
    trend: 	15.3
  },
  {
    name: 'Capacite Ltd',
    entry: '₹ 340',
    entryDate:'	07 Apr 2025',
    exitDate:'16 Apr 2025',
    exit: '₹ 360',
    returns: '5.8%',
    trend: 	5.8
  },
    {
    name: 'Times Guaranty',
    entry: '₹ 165',
    entryDate:'3 Mar 2025',
    exitDate:'8 Apr 2025',
    exit: '₹ 190',
    returns: '15.5%',
    trend: 15.5
  },
  {
    name: 'Digi Drive Ltd',
    entry: '₹ 33.6',
    entryDate:'21 Feb 2025',
    exitDate:'28 Feb 2025',
    exit: '₹ 30.9',
    returns: '-8.0%',
    trend: -8.0
  },
  {
    name: 'One Point Solutions',
    entry: '₹ 46.1',
    entryDate:'18 Feb 2025',
    exitDate:'25 Feb 2025',
    exit: '₹ 52.6',
    returns: '10.3%',
    trend: 	10.3
  },
    {
    name: 'India Glycols Ltd',
    entry: '₹ 1218',
    entryDate:'13 Jan 2025',
    exitDate:'6 Feb 2025',
    exit: '₹ 1370',
    returns: '8.40%',
    trend: 8.40
  },
  {
    name: 'Bajaj Finserv',
    entry: '₹ 1577',
    entryDate:'01 Jan 2025',
    exitDate:'23 Jan 2025',
    exit: '₹ 1745',
    returns: '10.07%',
    trend: 	10.07
  },
  {
    name: 'NIPPON ETF HANG SENG BEES',
    entry: '₹ 281',
    entryDate:'3 May 2024',
    exitDate:'10 May 2024',
    exit: '₹ 308',
    returns: '10%',
    trend: 	10
  },
{
    name: 'Bombdyeing Ltd',
    entry: '₹ 217',
    entryDate:'15 Jul 2024',
    exitDate:'24 Jul 2024',
    exit: '₹ 237',
    returns: '9%',
    trend: 	9
  },
{
    name: 'ABDL Ltd',
    entry: '₹ 314',
    entryDate:'14 Nov 2024',
    exitDate:'6 Dec 2024',
    exit: '₹ 357',
    returns: '14%',
    trend: 	14
  },
{
    name: 'HFCL Ltd',
    entry: '₹ 127',
    entryDate:'21 Nov 2024',
    exitDate:'20 Dec 2024',
    exit: '₹ 119',
    returns: '-6%',
    trend: 	-6
  },
{
    name: 'ELECON ENGINEERING',
    entry: '₹ 1016',
    entryDate:'16 Apr 2024',
    exitDate:'19 Apr 2024',
    exit: '₹ 1115',
    returns: '10%',
    trend: 	10
  },
{
    name: 'Shilpa Med Ltd',
    entry: '₹ 513',
    entryDate:'15 Apr 2024',
    exitDate:'29 Apr 2024',
    exit: '₹ 549',
    returns: '7%',
    trend: 	7
  },
{
    name: 'TFCIL',
    entry: '₹ 164',
    entryDate:'19 Sep 2024',
    exitDate:'23 Sep 2024',
    exit: '₹ 177',
    returns: '8%',
    trend: 	8
  },
  {
    name: 'Indus tower',
    entry: '₹ 343',
    entryDate:'29 Oct 2024',
    exitDate:'5 Dec 2024',
    exit: '₹ 369',
    returns: '8%',
    trend: 	8
  }
];


const Momentum = () => {

    const [form, setForm] = useState({ name: '', mobile: '', email: '' });
    const [submitted, setSubmitted] = useState(false);
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [swiperReady, setSwiperReady] = useState(false);
    const [productFeatures, setProductFeatures] = useState([]);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
      // Ensure Swiper re-renders after refs are attached
      window.scrollTo(0, 0);
      setSwiperReady(true);
      if (window.innerWidth <= 500) {
        setProductFeatures(features.slice(0, 4));
      } else {
        setProductFeatures(features);
      }
    }, []);
    

    const handleFormChange = (e) => {
      setForm({ ...form, [e.target.name]: e.target.value });
      // if(e.target.value && e.target.value.length <11){
      //   setForm({ ...form, [e.target.name]: e.target.value });
      // }
    };
    const handleFormSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
        // // You can add your submit logic here (API call, etc.)
        // setTimeout(() => setSubmitted(false), 2000);
        // setForm({ name: '', mobile: '', email: '' });

        leadServiceHelper.submitMobileNumberService(form,()=>{
          setTimeout(() => setSubmitted(false), 2000);
          setForm({ name: '', mobile: '', email: '' });
          // navigate('/products/premium/thankyou',{ state: { product: 'premium' } });
        })
    };

    const toggleExpand = () => {
      if (!expanded) {
        setProductFeatures(features);
        setExpanded(!expanded);
      }else {
        setProductFeatures(features.slice(0, 4));
        setExpanded(!expanded);
      }
    };

    useEffect(() => {
        document.title = "Niveza - Momentum Plan";
        // Load Elfsight script only once
        const scriptId = 'elfsight-platform-script';
        if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://elfsightcdn.com/platform.js';
        script.async = true;
        document.body.appendChild(script);
        }
    }, []);

    return (
        <>
            <Headers/>
            <Celebration/>
            {window.innerWidth >= 500 ?
            <div className="top-price">
              <div className="premium-footer">
                  <div className="premium-price">
                      {/* <span style={{fontFamily:'bold',color:'white'}}>Start with </span> */}
                      <div><span className="premium-price-value">₹ 20,000</span> <span className="premium-price-gst">+GST</span></div>
                  </div>
                  <div className="premium-contact-form-container" >
                      <div className="premium-form-section" >
                        <form className="premium-form" onSubmit={handleFormSubmit}>
                          <div>
                            <input
                              type="tel"
                              name="mobile"
                              placeholder= {window.innerWidth <= 500 ? "Mobile Number" : "Enter mobile number"}  
                              className= 'premium-form-input'
                              value={form.mobile}
                              onChange={handleFormChange}
                              pattern="^(?:\d-?){10}$"
                              required
                              onInvalid={e => e.target.setCustomValidity("Please enter a valid 10‑digit mobile number")} 
                              onInput={e => e.target.setCustomValidity("")}
                            />
                            <button type="submit" disabled={submitted} >
                              {submitted ? 'Submitted!' : 'Get a call back'}
                            </button>
                          </div>
                        </form>
                      </div>
                      <span className='cta_or'>Or</span>
                      <div className="premium-contact">
                        {window.innerWidth <= 500 ? <span style={{fontFamily:'bold'}}>Click to call</span> : <></>}  
                        <span className="premium-contact-phone">{window.innerWidth <= 500 ? <a href="tel:+919607527770">+91-96075-27770</a> : <span style={{fontFamily:'bold',color:'white'}}>+91-96075-27770</span>} </span>
                      </div>
                  </div>
              </div>
            </div> : ''}
            <div className="premium-container">
                <div className="premium-header">
                <img src="/images/premium/logo_p360.png" alt="Premium" className="premium-logo" />
                <span className="premium-title">
                    5-10% Returns Objective<sup>*</sup> Over 2-6 Weeks
                </span>
                </div>
                <div className="premium-features">
                {productFeatures.map((f, i) => (
                    <div className="premium-feature" key={i}>
                    <img src={f.icon} alt={f.title} className="premium-feature-icon" />
                    <div>
                        <div className="premium-feature-title">{f.title}</div>
                        <div className="premium-feature-desc">{f.desc}</div>
                    </div>
                    </div>
                ))}
                </div>
                {
                  window.innerWidth <= 500 ?
                    <div onClick={toggleExpand} className="expand-text"> {expanded? '<<Less' : 'Click to see more>>'}</div> : ' '
                }


                <div style={{  paddingBottom:'8px', marginTop:'40px' }}>
                  <span style={{display: 'block',width: '100%',textAlign: 'center',fontWeight:'bold',color:'#3cb371',fontSize:'clamp(1.3rem, 4vw, 1.6rem)'}}>Latest Research Calls You Missed!</span>
                </div>


                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
                  <div ref={prevRef} style={{ cursor: 'pointer' }}>
                    {/* <BiArrowFromRight size={44} /> */}
                    <button
                      style={{
                        backgroundColor: "#3cb371",
                        border: "none",
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <FaAngleLeft color="white" size={22} />
                    </button>                    
                  </div>
                  {swiperReady && (
                    <Swiper
                      modules={[Navigation]}
                      spaceBetween={56}
                      slidesPerView={"auto"}
                      grabCursor={true}
                      style={{ padding: "1rem" }}

                      loop={true}
                      navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                      }}
                      onBeforeInit={(swiper) => {
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                      }}
                      breakpoints={{
                        320: { slidesPerView: 1 },
                        600: { slidesPerView: 2 },
                        900: { slidesPerView: 3 },
                        1200: { slidesPerView: 3 },
                      }}
                    >
                      {researchCalls.map((call, i) => (
                        <SwiperSlide key={i} className="slider-card">
                          <StatisticCard
                            className="statistic-card"
                            // style={{  height: '220px' }}
                            style={{  border: '2px solid green' }}
                          >
                            <div className='statsDesc'>
                              <div>
                                {
                                window.innerWidth >= 500 ?
                                  <>
                                    <div style={{ textAlign:'center'}}><span style={{ fontWeight: 'bold',fontSize:'18px' }}>{call.name}</span></div>
                                    <br></br>
                                    <div className='returns'>Returns: &nbsp;&nbsp;&nbsp;<b>{call.returns}{call.trend>0?<FaArrowUp color='green'/>:<FaArrowDown color='red'/>}</b></div>
                                    <div>Entry Price: &nbsp;&nbsp; <b>{call.entry}</b></div>
                                    <div>Entry Date: &nbsp;&nbsp;&nbsp; <b>{call.entryDate}</b></div>
                                    <div>Exit Price:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  <b>{call.exit}</b></div>
                                    <div>Exit Date: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>{call.exitDate}</b></div>
                                  </>:
                                  <>
                                    <div style={{ textAlign:'center'}}><span style={{ fontWeight: 'bold',fontSize:'18px' }}>{call.name}</span></div>
                                    <br></br>
                                    <div className='returns'>Returns:&nbsp;&nbsp;<b>{call.returns}{call.trend>0?<FaArrowUp color='green'/>:<FaArrowDown color='red'/>}</b></div>
                                    <div>Entry Price:&nbsp;<b>{call.entry}</b></div>
                                    <div>Entry Date:&nbsp;<b>{call.entryDate}</b></div>
                                    <div>Exit Price:&nbsp;&nbsp;&nbsp;<b>{call.exit}</b></div>
                                    <div>Exit Date:&nbsp;&nbsp;&nbsp;<b>{call.exitDate}</b></div>
                                  </>
                                }
                              </div>
                            </div>
                          </StatisticCard>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  )}
                  <div ref={nextRef} style={{ cursor: 'pointer' }}>
                    {/* <BiArrowFromLeft size={44} /> */}
                    <button
                      style={{
                        backgroundColor: "#3cb371",
                        border: "none",
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <FaAngleRight color="white" size={22} />
                    </button>                    
                  </div>
                </div>                



                {/* <div>
                    <div  className="google-reviews-section">
                        <div className="elfsight-app-28d4333b-031d-43dd-a616-8a3ae9781d51" data-elfsight-app-lazy></div>
                    </div>
                </div> */}

                <div class="elfsight-app-b0efdf6e-91e0-446f-869a-399f7905e1fc" data-elfsight-app-lazy></div>
              
              {window.innerWidth <= 500 ?
                <div className="premium-footer">
                    <div className="premium-price">
                        <span>Start with </span>
                        <div><span className="premium-price-value">₹ 20,000</span> <span className="premium-price-gst">+GST</span></div>
                    </div>
                    <div className="premium-contact-form-container">
                        <div className="premium-contact">
                            {window.innerWidth <= 500 ? <span style={{fontFamily:'bold'}}>Click to call</span> : <></>}  
                            <span className="premium-contact-phone">{window.innerWidth <= 500 ? <a href="tel:+919607527770">+91-96075-27770</a> : <span style={{fontFamily:'bold',color:'black'}}>+91-96075-27770</span>} </span>
                        </div>
                        <span style={{fontWeight:'bold'}}>Or</span>
                        <div className="premium-form-section">
                            <form className="premium-form" onSubmit={handleFormSubmit}>
                              <div>
                                <input
                                    type="tel"
                                    name="mobile"
                                    placeholder="Enter your mobile number"
                                    value={form.mobile}
                                    onChange={handleFormChange}
                                    pattern="^(?:\d-?){10}$"
                                    required
                                />
                                <button type="submit" disabled={submitted}>
                                    {submitted ? 'Submitted!' : 'Get a call back'}
                                </button>
                              </div>
                            </form>
                        </div>
                    </div>

                </div>: ''}
                
                {/* <div className="premium-form-section">
                    <h3>Get in Touch</h3>
                    <form className="premium-form" onSubmit={handleFormSubmit}>
                        <input
                            type="text"
                            name="name"
                            placeholder="Enter your name"
                            value={form.name}
                            onChange={handleFormChange}
                            required
                        />
                        <input
                            type="tel"
                            name="mobile"
                            placeholder="Enter your mobile number"
                            value={form.mobile}
                            onChange={handleFormChange}
                            pattern="[0-9]{10}"
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="Enter your email address"
                            value={form.email}
                            onChange={handleFormChange}
                            required
                        />
                        <button type="submit" disabled={submitted}>
                            {submitted ? 'Submitted!' : 'Submit'}
                        </button>
                    </form>
                </div> */}

              <div className="video-reviews-header">
                <h2>
                  Explore <span>Other Products</span>
                </h2>
                {/* <p>Real feedback from our satisfied customers</p> */}
              </div>
              <ProductCards plans={plans}/>
                
            </div>
            <p style={{textAlign: 'center',fontFamily:'bold',color:'grey',fontSize:'0.8rem'}}>*Investments in stocks are subject to market risk. There is no assurance or gaurantee that objectives of the products on this site will be achieved.</p>
            <Footer/>
        </>
    )
};

export default Momentum;